module.exports = __webpack_public_path__ + "static/img/tutorial.23c9539.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tutorial.jpg
// module id = zI0O
// module chunks = 1